export default __webpack_public_path__ + "static/media/nexusBackground.677f5888.jpg";